import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  FormTextarea,
} from "@/components/ui";

interface DeclineQuoteDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  isSubmitting?: boolean;
}

/** Gates POST /v2/quotes/:id/decline behind a required reason. */
export function DeclineQuoteDialog({
  open,
  onCancel,
  onConfirm,
  isSubmitting,
}: DeclineQuoteDialogProps) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} ariaLabel="Decline quote">
      <DialogContent size="sm">
        <DialogHeader onClose={onCancel}>Decline quote</DialogHeader>
        <DialogBody>
          <FormTextarea
            label="Decline reason"
            required
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why is the client declining?"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={!reason.trim() || isSubmitting}
            onClick={() => onConfirm(reason.trim())}
          >
            {isSubmitting ? "Saving..." : "Decline quote"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
